import { render } from "./GreenClose.vue?vue&type=template&id=a9e30986&scoped=true"
const script = {}

import "./GreenClose.vue?vue&type=style&index=0&id=a9e30986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9e30986"]])

export default __exports__